import React, { useState, useEffect } from 'react';

interface MonthYearProp {
	keys?: string;
	onDateSelection: (date: string) => void;
}

const MonthYearSelector: React.FC<MonthYearProp> = ({ keys,onDateSelection }) => {
	const currentDate = new Date();
	const currentYear = currentDate.getFullYear();
	const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
	const defaultMonth = `${currentYear}-${currentMonth}`;
	const [isMonthInputSupported, setIsMonthInputSupported] = useState<boolean>(true);

	// Check if the browser supports <input type="month">
	useEffect(() => {
		const testInput = document.createElement("input");
		testInput.setAttribute("type", "month");
		if (testInput.type !== "month") {
			setIsMonthInputSupported(false);
		}
	}, []);

	const handleDateChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
		const value = e.target.value;
		if (!value) {
			handleSelectAll();
			return;
		};

		const formattedDate = `${value}-01`; // Convert to YYYY-MM-01
		onDateSelection(formattedDate);
	};

	// Generate months for dropdown
	const generateMonths = () => {
		const months = [];
		const currentDate = new Date();
	
		for (let i = 0; i < 12; i++) {
			const date = new Date(currentDate);
			date.setMonth(date.getMonth() - i);
	
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, "0");
	
			months.push(`${year}-${month}`);
		}
	
		return months;
	};

	// Handle "Select All" click
	const handleSelectAll = () => {
		onDateSelection(""); // Set selectedDate as an empty string
	};

	return (
		<div>
			<div className="input-box-calendar">
				{/* Native input if supported */}
				{isMonthInputSupported ? (
					<input
						title="monthInput"
						type="month"
						onChange={handleDateChange}
						min={`${currentYear-1}-${currentMonth}`}
						max={defaultMonth}
						value={keys && keys.slice(0, 7)}
						required
						style={{ marginBottom: 0, paddingBottom: 0, height: '14px' }}
					/>
				) : (
					// Fallback for Firefox: Use <select>
					<select title="monthInput" onChange={handleDateChange} value={keys && keys.slice(0, 7)}>
						{generateMonths().map((month) => (
							<option key={month} value={month}>
								{month}
							</option>
						))}
					</select>
				)}
			</div>
		</div>
	);
};

// Transparent placeholder that occupies the exact same footprint as
// MonthYearSelector. Used to keep UI alignment intact where the pool_month
// filter is hidden (e.g. for agency-side users).
export const MonthYearSelectorPlaceholder: React.FC = () => (
	<div>
		<div
			className="input-box-calendar"
			style={{ border: '1px solid transparent', backgroundColor: 'transparent', height: '14px' }}
			aria-hidden="true"
		/>
	</div>
);

export default MonthYearSelector;
